/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TaskStatusType } from './TaskStatusType.js';
import {
    TaskStatusTypeFromJSON,
    TaskStatusTypeFromJSONTyped,
    TaskStatusTypeToJSON,
} from './TaskStatusType.js';

/**
 * 
 * @export
 * @interface CreateTaskRequest
 */
export interface CreateTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskRequest
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskRequest
     */
    assignedTo?: number;
    /**
     * 
     * @type {Date}
     * @memberof CreateTaskRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateTaskRequest
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskRequest
     */
    customerId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskRequest
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTaskRequest
     */
    priority?: number;
    /**
     * 
     * @type {TaskStatusType}
     * @memberof CreateTaskRequest
     */
    status?: TaskStatusType;
}

/**
 * Check if a given object implements the CreateTaskRequest interface.
 */
export function instanceOfCreateTaskRequest(value: object): boolean {
    return true;
}

export function CreateTaskRequestFromJSON(json: any): CreateTaskRequest {
    return CreateTaskRequestFromJSONTyped(json, false);
}

export function CreateTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'content': json['content'] == null ? undefined : json['content'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'status': json['status'] == null ? undefined : TaskStatusTypeFromJSON(json['status']),
    };
}

export function CreateTaskRequestToJSON(value?: CreateTaskRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'assignedTo': value['assignedTo'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'content': value['content'],
        'customerId': value['customerId'],
        'contactId': value['contactId'],
        'priority': value['priority'],
        'status': TaskStatusTypeToJSON(value['status']),
    };
}

